// extracted by mini-css-extract-plugin
module.exports = {"sales":"style_sales__2ESh3","table":"style_table__2T3UU","loading":"style_loading__o_s7x","showMore":"style_showMore__3o_EG"};